import { RefObject, useEffect, useState } from "react";

export const useCheckDistanceFromBottom = (ref: RefObject<HTMLElement>) => {
  const [distanceFromBottom, setDistanceFromBottom] = useState(0);

  useEffect(() => {
    const checkDistance = () => {
      if (ref.current) {
        const distanceFromBottom =
          window.innerHeight - ref.current.getBoundingClientRect().bottom;

        setDistanceFromBottom(distanceFromBottom);
      }
    };

    window.addEventListener("scroll", checkDistance);

    return () => {
      window.removeEventListener("scroll", checkDistance);
    };
  }, []);

  return distanceFromBottom;
};
